type Named = { firstName?: string | null, lastName?: string | null, email?: string | null, username?: string | null }

/** Prénom et nom, ou vide : le nom tel qu'il s'imprime sur une carte d'identifiants (#271). */
export function userFullName({ firstName, lastName }: Pick<Named, 'firstName' | 'lastName'>): string {
  return `${firstName ?? ''} ${lastName ?? ''}`.trim()
}

/**
 * Comment un écran nomme une personne : prénom et nom, à défaut son adresse, à
 * défaut son pseudo (apprenant sans e-mail, #271).
 */
export function userDisplayName(person: Named): string {
  return userFullName(person) || person.email || person.username || ''
}
